export default __webpack_public_path__ + "static/media/login-image.9041195a.jpeg";